import React from 'react';
import Styles from './styles.module.css';
import Loader from '../../assets/svg/loader.svg';

const ProfileSelector = ({
    profiles,
    selectedProfile,
    onProfileSelect,
    isLoading,
    getImportTypeDisplay
}) => {
    const handleProfileClick = (profile) => {
        onProfileSelect(profile);
    };

    return (
        <div className={Styles.container}>
            <div className={Styles.card}>
                <h3 className={Styles.title}>Import-Profil auswählen</h3>

                {isLoading ? (
                    <div className={Styles.loading}>
                        <img src={Loader} width={30} height={30} alt="Loading" />
                        <span>Lade Profile...</span>
                    </div>
                ) : profiles.length === 0 ? (
                    <div className={Styles.noProfiles}>
                        <p>Keine Profile gefunden.</p>
                        <p>Erstellen Sie zuerst ein Profil im Einstellungen-Tab.</p>
                    </div>
                ) : (
                    <div className={Styles.profileList}>
                        <div className={Styles.profileHeader}>
                            <span>Name</span>
                            <span>Import-Typ</span>
                            <span>Verkaufskanal</span>
                        </div>
                        {profiles.map((profile) => (
                            <div
                                key={profile.id}
                                className={`${Styles.profileItem} ${
                                    selectedProfile?.id === profile.id ? Styles.selected : ''
                                }`}
                                onClick={() => handleProfileClick(profile)}
                            >
                                <div className={Styles.profileDetails}>
                                    <div className={Styles.profileName}>
                                        <strong>{profile.name}</strong>
                                        {profile.config?.description && (
                                            <p className={Styles.description}>
                                                {profile.config.description}
                                            </p>
                                        )}
                                    </div>
                                    <div className={Styles.importType}>
                                        <span className={Styles.typeLabel}>
                                            {getImportTypeDisplay(profile.config)}
                                        </span>
                                    </div>
                                    <div className={Styles.salesChannel}>
                                        {profile.salesChannel?.name || 'Standard'}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {selectedProfile && (
                    <div className={Styles.selectedProfile}>
                        <h4>Ausgewähltes Profil:</h4>
                        <div className={Styles.profileSummary}>
                            <p><strong>Name:</strong> {selectedProfile.name}</p>
                            <p><strong>Import-Typ:</strong> {getImportTypeDisplay(selectedProfile.config)}</p>
                            <p><strong>Verkaufskanal:</strong> {selectedProfile.salesChannel?.name || 'Standard'}</p>
                            {selectedProfile.config?.description && (
                                <p><strong>Beschreibung:</strong> {selectedProfile.config.description}</p>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ProfileSelector;